module.exports = __webpack_public_path__ + "img/f3239b8.png";